import {clsx} from '@gfiber/typesmith';
import {Accordion as BaseAccordion} from '@base-ui/react/accordion';
import type * as React from 'react';
import styles from './Accordion.module.scss';

export interface AccordionDetailProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  keepMounted?: boolean;
}

export const AccordionDetails: React.FC<AccordionDetailProps> = ({
  children,
  className,
  contentClassName,
  keepMounted,
}) => {
  return (
    <BaseAccordion.Panel
      keepMounted={keepMounted}
      className={clsx(styles.panel, className)}
    >
      <div className={clsx(styles.content, contentClassName)}>{children}</div>
    </BaseAccordion.Panel>
  );
};
